module.exports = __webpack_public_path__ + "static/media/bg-palm.f0b0a7d8.svg";